<template>
  <div class="field-item">
    <div class="label">
      {{ field.name }}
      <el-tooltip v-if="field._type === 'file' || field.id === 'attachments'" content="历史版本">
        <span @click="showFileHistory(control._cid)" class="icon-tip pointer">
          <svg-icon icon-class="svgo_history" style="font-size: 18px"></svg-icon>
        </span>
      </el-tooltip>
      <!-- 控件提示 -->
      <!-- <el-tooltip v-if="control.description" :content="control.description" placement="bottom">
        <span class="icon-tip pointer">
          <i class="el-icon-info"></i>
        </span>
      </el-tooltip> -->
    </div>
    <div class="value">
      <template v-if="field._type === 'file'">
        <!-- 用于获取附件历史 -->
        <file-control ref="fileControl" :files="[]" :control="control"></file-control>
      </template>
      <span v-if="isEmpty" class="is-empty">{{ emptyText }}</span>
      <file-control
        v-else-if="field._type == 'file'"
        ref="fileControl"
        :files="value"
        :control="control"
      ></file-control>
      <ref-control v-else-if="field._type == 'ref'" :control="control" :list="value"></ref-control>
      <span v-else-if="field._type == 'remark'">{{ control.hint }}</span>
      <parent-task v-else-if="field.id == 'parentTask'" :parent-task="value"></parent-task>
      <span
        v-else-if="field.id === 'remark' || field._type === 'rich' || field.id === 'copingPlan'"
        v-viewer="{ backdrop: 'static' }"
      >
        <span v-html="value" class="rich-field"></span>
      </span>
      <file-control
        v-else-if="field.id === 'attachments'"
        ref="fileControl"
        :files="value"
        control-id="attachment"
      ></file-control>
      <staff-popover
        v-else-if="['leader', 'creator', 'completeUser'].includes(field.id)"
        :staffId="value.id"
      >
        <template v-slot:reference>
          <span>{{ value.name }}</span>
        </template>
      </staff-popover>
      <span v-else>
        {{ value }}
        <span v-if="field.id == 'status' && isOverdue.status" class="is-overdue">
          逾期 {{ isOverdue.days }} 天
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import FileControl from "@/components/Sheet/DetailDialog/DataDetail/FieldItem/FileControl"
import RefControl from "./RefControl"
import ParentTask from "./ParentTask"
import StaffPopover from "@/components/BaseComponents/StaffPopover"

export default {
  name: "field-item",
  components: {
    FileControl,
    RefControl,
    ParentTask,
    StaffPopover
  },
  props: {
    field: {
      type: Object,
      default: () => ({})
    },
    value: [Number, String, Array, Object],
    emptyText: String,
    control: {
      type: Object,
      default: () => ({})
    },
    isOverdue: Object
  },
  computed: {
    isEmpty() {
      if (this.field._type == "remark") return false
      if (!this.value || (Array.isArray(this.value) && this.value.length == 0)) return true
      return false
    }
  },
  methods: {
    showFileHistory(controlId) {
      this.$refs.fileControl?.showFileHistory(controlId)
    }
  }
}
</script>

<style lang="scss" scoped>
.field-item {
  display: flex;
  min-height: 40px;
  align-items: center;
  .label {
    display: flex;
    align-items: center;
    width: 140px;
    min-width: 140px;
    margin-right: 30px;
    line-height: 20px;
    padding: 10px 0;
    .icon-tip {
      font-size: 16px;
      margin-left: 4px;
      &:hover {
        color: #3aacf8;
      }
    }
  }
  .value {
    flex: auto;
    padding: 9px 0;
    overflow: hidden;
    .is-empty {
      color: $color-font-second;
    }
    .is-overdue {
      display: inline-block;
      margin-left: 2px;
      font-size: 12px;
      padding: 2px 10px;
      border-radius: 16px;
      color: $color-auxiliary;
      border: 1px solid rgba($color-auxiliary, 0.5);
      background-color: rgba($color-auxiliary, 0.1);
    }
    .rich-field {
      ::v-deep p {
        margin: 0;
      }
      ::v-deep {
        ol {
          padding-inline-start: 16px;
        }
        ol li {
          list-style: decimal;
        }
        ul {
          padding-inline-start: 16px;
        }
        ul li {
          list-style: disc;
        }
      }
    }
  }
}
</style>
